<template>
  <div class="article-list">
    <like v-if="!isMobile"></like>
    <Side></Side>
    <div class="article-list-content">
      <div class="article-header">
        <ul class="article-header-list">
          <li
            class="article-header-list-item"
            :class="{'active' : articleType === 'all'}"
            @click="getArticle('all')"
          >
            <span class="text">最新</span>
          </li>
          <li class="article-header-list-item"
            :class="{'active' : articleType === 'news'}"
            @click="getArticle('news')"
            >
            <span class="text">公告</span>
          </li>
          <li class="article-header-list-item"
            :class="{'active' : articleType === 'guides'}"
            @click="getArticle('guides')"
          >
            <span class="text">攻略</span>
          </li>
          <li class="article-header-list-item article-header-list-item-last"
            :class="{'active' : articleType === 'events'}"
            @click="getArticle('events')"
          >
            <span class="text">活動</span>
          </li>
        </ul>
        <p class="curr-location">當前位置：<a class="to-index" href="./index.html">首頁</a> > 新聞</p>
      </div>
      <div class="article-main">
        <ul class="article-main-list" v-show="articleType === 'all'">
          <li class="article-main-list-item" v-for="(item, index) in article.all" :key="index">
            <a :href="'./index.html#/article-detail?id=' + item.ID">
              <div class="article-main-list-item-title">
                <span class="article-main-list-item-title-inner">
                  {{item.TITLE || item.SHORT_TITLE}}
                </span>
                <span class="description">{{item.DESCRIPTION}}</span>
              </div>
              <span class="article-main-list-item-date">{{item.PUBLISH_TIME.substring(5, 10)}}</span>
              <span class="year">{{item.PUBLISH_TIME.substring(0, 4)}}</span>
              <span class="to-detail"></span>
            </a>
          </li>
        </ul>
        <ul class="article-main-list" v-show="articleType === 'news'">
          <li class="article-main-list-item" v-for="(item, index) in article.news" :key="index">
            <a :href="'./index.html#/article-detail?id=' + item.ID + '&type=news'">
              <span class="article-main-list-item-title">
                <span class="article-main-list-item-title-inner">
                  {{item.TITLE || item.SHORT_TITLE}}
                </span>
                <span class="description">{{item.DESCRIPTION}}</span>
              </span>
              <span class="article-main-list-item-date">{{item.PUBLISH_TIME.substring(5, 10)}}</span>
              <span class="year">{{item.PUBLISH_TIME.substring(0, 4)}}</span>
              <span class="to-detail"></span>
            </a>
          </li>
        </ul>
        <ul class="article-main-list" v-show="articleType === 'guides'">
          <li class="article-main-list-item" v-for="(item, index) in article.guides" :key="index">
            <a :href="'./index.html#/article-detail?id=' + item.ID + '&type=guides'">
              <span class="article-main-list-item-title">
                <span class="article-main-list-item-title-inner">
                  {{item.TITLE || item.SHORT_TITLE}}
                </span>
                <span class="description">{{item.DESCRIPTION}}</span>
              </span>
              <span class="article-main-list-item-date">{{item.PUBLISH_TIME.substring(5, 10)}}</span>
              <span class="year">{{item.PUBLISH_TIME.substring(0, 4)}}</span>
              <span class="to-detail"></span>
            </a>
          </li>
        </ul>
        <ul class="article-main-list" v-show="articleType === 'events'">
          <li class="article-main-list-item" v-for="(item, index) in article.events" :key="index">
            <a :href="'./index.html#/article-detail?id=' + item.ID + '&type=events'">
              <span class="article-main-list-item-title">
                <span class="article-main-list-item-title-inner">
                  {{item.TITLE || item.SHORT_TITLE}}
                </span>
                <span class="description">{{item.DESCRIPTION}}</span>
              </span>
              <span class="article-main-list-item-date">{{item.PUBLISH_TIME.substring(5, 10)}}</span>
              <span class="year">{{item.PUBLISH_TIME.substring(0, 4)}}</span>
              <span class="to-detail"></span>
            </a>
          </li>
        </ul>
      </div>
      <div class="pc-next-page" v-if="totalPage > 1 && !isMobile">
        <span class="prev" @click="getArticlePCPage(currPage - 1)">上一页</span>
        <span class="curr">{{currPage}}/{{totalPage}}</span>
        <span class="next" @click="getArticlePCPage(currPage + 1)">下一页</span>
      </div>
    </div>
    <span class="mobile-next-page" v-if="showMobileNextPage" @click="getArticle(articleType, true)"></span>
  </div>
</template>

<script>
import Side from '@/components/Side.vue'
import { getUrlParam } from '../utils/utils'
import { mapGetters, mapMutations } from 'vuex'
import Like from '../components/Like.vue'
import { GAME_ID,
  GET_ARTICLE_LIST,
  ARTICLE_TYPE,
  SET_NAV_ARTICLE_TYPE
} from '../store/config'
let initArticleType = getUrlParam('type')
const MOBILE_LIST_NUM = 8
const PC_LIST_NUM = 5

export default {
  data () {
    return {
      articleType: initArticleType,
      isInRequest: false,
      article: {
        all: [],
        news: [],
        guides: [],
        events: []
      },
      currPage: 0,
      totalPage: 1
    }
  },
  computed: {
    ...mapGetters([
      'navArticleType',
      'deviceType'
    ]),
    isMobile () {
      return this.deviceType === 'mobile'
    },
    showMobileNextPage () {
      return this.isMobile && (this.totalPage > this.currPage)
    }
  },
  created () {
    this.getArticle(initArticleType || 'all')
  },
  methods: {
    getArticle (type, fromMoreArticle) {
      if (this.isInRequest) {
        return
      }
      this.currPage = this.articleType !== type ? 1 : this.currPage + 1
      this.articleType = type
      this.isInRequest = true
      this.setNavArticleType(type)
      const params = {
        gameId: GAME_ID,
        type: ARTICLE_TYPE[type],
        page: this.currPage,
        num: this.isMobile ? MOBILE_LIST_NUM : PC_LIST_NUM
      }
      this.$store.dispatch(GET_ARTICLE_LIST, params).then((res) => {
        this.totalPage = Math.ceil(res.total / (this.isMobile ? MOBILE_LIST_NUM : PC_LIST_NUM))
        if (fromMoreArticle) {
          this.article[type] = [...this.article[type], ...res.list]
        } else {
          this.article[type] = res.list
        }
        this.isInRequest = false
      })
    },
    getArticlePCPage (targetPage) {
      if (targetPage < 1 || targetPage > this.totalPage) {
        return
      }
      this.currPage = targetPage
      const params = {
        gameId: GAME_ID,
        type: ARTICLE_TYPE[this.articleType],
        page: targetPage,
        num: PC_LIST_NUM
      }
      this.$store.dispatch(GET_ARTICLE_LIST, params).then((res) => {
        this.totalPage = Math.ceil(res.total / (this.isMobile ? MOBILE_LIST_NUM : PC_LIST_NUM))
        this.article[this.articleType] = res.list
      })
    },
    ...mapMutations({
      'setNavArticleType': SET_NAV_ARTICLE_TYPE
    })
  },
  components: {
    Side,
    Like
  },
  watch: {
    navArticleType (newType) {
      this.getArticle(newType)
    }
  }
}
</script>

<style lang="scss">
  @import "@/assets/scss/base.scss";
  @import "@/assets/scss/article.scss";
</style>
